module.exports = __webpack_public_path__ + "img/icon_book.58863fd2.png";